import { SnackbarContext } from "common/SnackbarProvider";
import { useContext } from "react";

const useSnackbar = () => useContext(SnackbarContext);
export default useSnackbar;